import { Box, Grid } from "@mui/material";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { ClaimResource } from "types/claimTypes";

const ContentPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    productsUrl,
    resourcesUrl,
    skusUrl,
    seriesUrl,
    questionsUrl,
    evaluationsUrl,
    mediaLibraryUrl,
    notificationsUrl,
    resourceLibrariesUrl,
    scormUrl,
    skuUserAgreementsUrl,
    agreementsUrl,
    attributesUrl,
  } = useGlobalContext();

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <ClaimBasedComponent requestedClaims={[ClaimResource.Products]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "menubarProducts" })} url={productsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Skus]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "menubarSkus" })} url={skusUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Series]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "menubarSeries" })} url={seriesUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Evaluations]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "evaluationsLabel" })}
              url={evaluationsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Questions]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarQuestions" })}
              url={questionsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Resources]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "facultyLabel" })} url={resourcesUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.MediaLibrary]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "mediaLibrary" })} url={mediaLibraryUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Notifications]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "notifications" })}
              url={notificationsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.ResourceLibraries]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarResourceLibraries" })}
              url={resourceLibrariesUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Rustici]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "scorm" })} url={scormUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Agreements]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "agreements" })} url={agreementsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Agreements]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "userAgreements" })}
              url={skuUserAgreementsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Attributes]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "attributes" })} url={attributesUrl()} />
          </Grid>
        </ClaimBasedComponent>
      </Grid>
    </Box>
  );
};

export default ContentPage;
